export default {
    shipmentDirections: [],
    searchOptions: [],
    deliveryStatuses: [],
    salesProducts: [],
    transportCompanies: [],
    accounts: [],
    filter: null,
    selectedRows: [],
    shipments: [],
    countries: []
};
